import resumePDF from "../assets/Mohamed_Ansaar_CV.pdf";

const About = () => {
  return (
    <div className="sec" id="about">
      <div className="wrap">
        <div className="sec-h"><span className="hash">##</span> abstract</div>

        <div className="prose about-grid">
          <div className="about-text">
            <p data-aos="fade-up">
              I'm <b>Mohamed Ansaar</b> — an analytics engineer and data professional from
              Tamil Nadu, India. Over <b>5+ years at BrightChamps (EdTech)</b> I was promoted
              four times while building reporting pipelines, evaluation frameworks, and
              ML-assisted solutions.
            </p>

            <p className="pull" data-aos="fade-up">
              I started by asking questions of data. Now I'm building the systems that answer them.
            </p>

            <p data-aos="fade-up">
              At BrightChamps I built <b>reporting automation with Python, Google Sheets &amp; Apps
              Script</b>, cutting manual effort <b>50–70%</b>. I designed end-to-end evaluation
              frameworks, delivered weekly insight reports to senior leadership, and drove analytics
              across <b>30% of cross-functional workflows</b>.
            </p>

            <p data-aos="fade-up">
              Day to day I work in <b>Python, SQL, Power BI, Looker Studio and Streamlit</b> —
              dashboards, ETL pipelines, and predictive models. I'm currently extending into the
              modern stack: <b>dbt, BigQuery, and deep-learning frameworks</b>, and I stay explicit
              about what's shipped versus what's still in training.
            </p>

            <p className="about-meta" data-aos="fade-up">
              path: <b>Analytics Engineer → ML Engineer → AI Engineer</b> ·
              B.E. Electronics &amp; Communication, Anjalai Ammal Mahalingam Engineering College, Tiruvarur
            </p>

            <div className="about-btns" data-aos="fade-up">
              <a href={resumePDF} target="_blank" rel="noopener noreferrer">
                <button className="mc-btn">view resume</button>
              </a>
              <a href={resumePDF} download>
                <button className="mc-btn ghost">download resume</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;